//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"AngleValue",1,0],[0,"Associative",1,0],[0,"EvaluationPlane",1,0],[0,"FirstMapView",1,"View",0],[1,"FirstObject",0,"SelectNXObject",0],[0,"FirstObjectType",1,0],[0,"FirstVector",1,"Direction",0],[0,"Plane",1,"Plane",0],[0,"ScalarObject",1,"Scalar",0],[0,"SecondMapView",1,"View",0],[1,"SecondObject",0,"SelectNXObject",0],[0,"SecondObjectType",1,0],[0,"SecondVector",1,"Direction",0]],[[[],"AlternateAngle",{},0,0],[[],"CreateScalarObject",{},0,0],[["isMeasure"],"SetIsMeasure",{},1,0],[["scalarTag","angleValue"],"CreateScalarObjectFromData",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.AssociativeAngleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.AssociativeAngleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.AssociativeAngleBuilder.ObjectType = Object.freeze({
    "Object" : "Object", "Vector" : "Vector"});

SPLM.Drawings.AssociativeAngleBuilder.EvaluationPlaneType = Object.freeze({
    "DrawingSheet" : "DrawingSheet", "TrueAngle" : "TrueAngle", "SpecifyPlane" : "SpecifyPlane"});

export default SPLM;